import { render, staticRenderFns } from "./LocationTodoView.vue?vue&type=template&id=ab889cfa"
import script from "./LocationTodoView.vue?vue&type=script&lang=js"
export * from "./LocationTodoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports